import { Link } from "react-router-dom";

const entries = [
  {
    icon: "ri-tv-2-line",
    title: "电视剧",
    desc: "热播剧集 · 全集剧情",
    to: "/category?category=电视剧",
  },
  {
    icon: "ri-movie-2-line",
    title: "电影",
    desc: "院线佳作 · 深度影单",
    to: "/category?category=电影",
  },
  {
    icon: "ri-book-open-line",
    title: "剧情介绍专题",
    desc: "分集剧情 · 人物脉络",
    to: "/category?genre=剧情",
  },
  {
    icon: "ri-fire-line",
    title: "最新更新",
    desc: "追更提醒 · 实时上线",
    to: "/category",
  },
];

export default function CategoryEntries() {
  return (
    <section className="w-full px-4 md:px-8 py-12 md:py-14">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
        {entries.map((e) => (
          <Link
            key={e.title}
            to={e.to}
            className="group flex items-center gap-4 p-4 md:p-5 rounded-lg bg-background-100 border border-background-200 hover:border-accent-300 hover:bg-background-50 transition-all duration-300 cursor-pointer"
          >
            <span className="w-12 h-12 md:w-14 md:h-14 shrink-0 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 group-hover:bg-accent-500 group-hover:text-primary-950 transition-colors">
              <i className={`${e.icon} text-2xl`}></i>
            </span>
            <span className="min-w-0">
              <span className="block font-heading text-sm md:text-base font-semibold text-foreground-950 whitespace-nowrap">
                {e.title}
              </span>
              <span className="block text-xs text-foreground-500 mt-0.5 whitespace-nowrap">{e.desc}</span>
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}